// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileMenu_wrapper__Bf3wl"};